/**
 * Send user action for LinkedIn conversion tracking
 * @param id
 */
export const lintrk = (id: number) => {
  // @ts-expect-error TS2339 because lintrk is injected by the LinkedIn tag #OVP-2982
  if (typeof window !== 'undefined' && typeof window.lintrk !== 'undefined') {
    // @ts-expect-error TS2339 because lintrk is injected by the LinkedIn tag #OVP-2982
    window.lintrk('track', { conversion_id: id })
  }
}
